/* 种畜禽接口 _LB(标识) */
import request from './axiosFun'; // 有 loading
import apiHttp from './apiHttp'; // 无 loading

var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

/* 用户基础信息接口 */
export function getSeedUserInfo_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/getSeedUserInfo',
    method: 'post',
    data
  });
}

/* 区域列表 */
export function getOpenInfoByCode_LB(data) {
  return request({
    url: url + '/seedstock/seedUser/getOpenInfoByCode',
    method: 'post',
    data
  });
}

/* 区域列表下级查询*/
export function getNationalInfoByProps_LB(data) {
  return request({
    url: url + '/base-server/userCore/getNationalInfoByProps',
    method: 'post',
    data
  });
}

/* 人员管理 - 新增 */
export function saveSeedUserInfo_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/saveSeedUserInfo',
    method: 'post',
    data
  });
}

/* 人员管理 - 编辑 */
export function updateSeedUserInfo_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/updateSeedUserInfo',
    method: 'post',
    data
  });
}

/* 人员管理 - 列表 */
export function getSeedUserInfos_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/getSeedUserInfos',
    method: 'post',
    data
  });
}

/* 用户角色统计 */
export function getSeedRoleCount_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/getSeedRoleCount',
    method: 'post',
    data
  });
}

/* 新增 - 角色查询 */
export function getSeedRoleList_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/getSeedRoleList',
    method: 'post',
    data
  });
}

/* 人员管理 - 删除 */
export function deleteSeedUser_LB(data) {
  return apiHttp({
    url: url + '/seedstock/seedUser/deleteSeedUser',
    method: 'post',
    data
  });
}

/* 人员管理 - 重置密码 */
export function resetPassword_LB(data) {
  return apiHttp({
    url: url + '/base-server/userCore/resetPassword',
    method: 'post',
    data
  });
}

/* 菜单管理 */
export function getAppMenuListCD_LB(data) {
  return request({
    url: url + '/base-server/loginCore/getAppMenuList',
    method: 'post',
    data
  });
}

/* 性能指标配置-列表 */
export function pageSeedPerformanceIndicatorConfig_LB(data) {
  return request({
    url: url + '/seedstock/seedPerformanceIndicatorConfig/pageSeedPerformanceIndicatorConfig',
    method: 'post',
    data
  });
}

/* 性能指标配置-品种 */
export function findAllVarietyType_LB(data) {
  return request({
    url: url + '/back-manager/seedPerformanceIndicatorConfig/findAllVarietyType',
    method: 'post',
    data
  });
}

/* 性能指标配置-设置 */
export function pageSeedconfig_LB(data) {
  return request({
    url: url + '/seedstock/seedPerformanceIndicatorConfig/config',
    method: 'post',
    data
  });
}

/* 种畜认证申请 - 列表 */
export function pageLivestock_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/pageLivestock',
    method: 'post',
    data
  });
}

/* 种畜认证申请 - 审核 */
export function auditedLivestock_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/auditedLivestock',
    method: 'post',
    data
  });
}
/* 种畜认证申请 - 史指标数据（未做） */
export function findIndicatorHistory_LB(data) {
  return request({
    url: url + '/seedstock/seedPerformanceIndicatorConfig/findIndicatorHistory',
    method: 'post',
    data
  });
}

/* 种畜管理 - 在栏种畜 - 导出 */
export function exportLivestock_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/exportLivestock',
    method: 'post',
    data
  });
}
/* 种畜管理 - 流转记录 - 列表 */
export function findLivestockSaleList_LB(data) {
  return request({
    url: url + '/seedstock/seedLivestockOperateInfo/findLivestockSaleList',
    method: 'post',
    data
  });
}
/* 种畜管理 - 无害化 - 列表 */
export function getHarmlessTreatmentPCPage_LB(data) {
  return request({
    url: url + '/seedstock/treatment/getHarmlessTreatmentPCPage',
    method: 'post',
    data
  });
}
/* 种畜管理 - 环境消杀 - 列表 */
export function getEnvironmentDisinfectPCPage_LB(data) {
  return request({
    url: url + '/seedstock/disinfect/getEnvironmentDisinfectPCPage',
    method: 'post',
    data
  });
}
/* 种畜管理 - 检测上报  - 列表 */
export function getCheckResultReportPCPage_LB(data) {
  return request({
    url: url + '/seedstock/checkInfo/getCheckResultReportPCPage',
    method: 'post',
    data
  });
}
/* 种畜管理 - 配种记录  - 列表 */
export function findBreedInfo_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/findBreedInfo',
    method: 'post',
    data
  });
}
/* 种畜管理 - 配种记录  - 查询蓄只根据批次号 */
export function findLivestockInfoByRecordNo_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/findLivestockInfoByRecordNo',
    method: 'post',
    data
  });
}
/* 种畜管理 - 生产记录 */
export function findProduceInfo_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/findProduceInfo',
    method: 'post',
    data
  });
}

/* 种畜管理 - 出栏记录 */
export function queryBatchSuch_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/queryBatchSuch',
    method: 'post',
    data
  });
}

/* 种畜管理 - 全部流转记录 */
export function findLivestockSaleListById_LB(data) {
  return request({
    url: url + '/seedstock/seedLivestockOperateInfo/findLivestockSaleListById',
    method: 'post',
    data
  });
}

/* 种畜管理 - 淘汰记录 - 列表 */
export function findLivestockOutList_LB(data) {
  return request({
    url: url + '/seedstock/seedLivestockOperateInfo/findLivestockOutList',
    method: 'post',
    data
  });
}

/* 种畜禽场管理 - 列表 */
export function findFarmPage_LB(data) {
  return request({
    url: url + '/seedstock/seed/farm/page',
    method: 'post',
    data
  });
}

/* 监控设备 - 列表 */
export function getFarmCameraSuggestList_LB(data) {
  return request({
    url: url + '/device/cameraDevice/getFarmCameraSuggestList',
    method: 'post',
    data
  });
}

/* 监控设备 - 推荐/取消推荐 */
export function suggestCamera_LB(data) {
  return request({
    url: url + '/device/cameraDevice/suggestCamera',
    method: 'post',
    data
  });
}

/* 监控设备 - 详情 */
export function getVideoHlsUrlToWeb_LB(data) {
  return request({
    url: url + '/device/cameraDevice/getVideoHlsUrlToWeb',
    method: 'post',
    data
  });
}

/* 主体管理 */
export function farmInfoPage_LB(data) {
  return request({
    url: url + '/seedstock/seed/farm/farmInfoPage',
    method: 'post',
    data
  });
}

/* 主体管理 - 新增  */
export function addSeedUserFarmInfoPc_LB(data) {
  return request({
    url: url + 'seedstock/seed/farm/addSeedUserFarmInfoPc',
    method: 'post',
    data
  });
}
/* 主体管理 - 编辑  */
export function updateSeedUserFarmInfo_LB(data) {
  return request({
    url: url + 'seedstock/seed/farm/updateSeedUserFarmInfo',
    method: 'post',
    data
  });
}
/* 主体管理 - 删除  */
export function deleteSeedUserFarmInfo_LB(data) {
  return request({
    url: url + 'seedstock/seed/farm/deleteSeedUserFarmInfo',
    method: 'post',
    data
  });
}

/* 主体管理 - 导入  */
export function importSubject_LB(data, deptId, openId) {
  return request({
    url: url + '/seedstock/seed/farm/importSubject/' + deptId + '/' + openId,
    method: 'post',
    data
  });
}

/* 主体管理 - 修改手机号  */
export function updateTelephone_LB(data) {
  return request({
    url: url + '/seedstock/seed/farm/updateTelephone',
    method: 'post',
    data
  });
}

/* 主体管理 - 开通应用 */
export function batchOpenSeedApp_LB(data) {
  return request({
    // url: url + '/seedstock/seed/farm/openSeedApp', // 单个开通
    url: url + '/seedstock/seed/farm/batchOpenSeedApp',
    method: 'post',
    data
  });
}

/* 饲喂品种 - 列表 */
export function getClassifyCattleType_LB(data) {
  return request({
    url: url + '/pasture/dynamicData/getClassifyCattleType',
    method: 'post',
    data
  });
}

/* 可视化 - 总览数据统计 */
export function findScreenDataOverview_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/findScreenDataOverview',
    method: 'post',
    data
  });
}

/* 可视化 - 在栏种畜统计 */
// export function findScreenDataLivestockCount_LB(data) {
//   return request({
//     url: url + '/seedstock/livestockInfo/findScreenDataLivestockCount',
//     method: 'post',
//     data
//   });
// }

/* 可视化 - 在栏种畜统计 */
export function findScreenDataLivestockCount_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/findScreenDataLivestockCountNew',
    method: 'post',
    data
  });
}

/* 可视化 - 辖区在栏种畜统计 */
export function findScreenDataAreaLivestockCount_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/findScreenDataAreaLivestockCount',
    method: 'post',
    data
  });
}

/* 可视化 - 流转记录统计 */
export function findScreenDataSaleCount_LB(data) {
  return request({
    url: url + '/seedstock/seedLivestockOperateInfo/findScreenDataSaleCount',
    method: 'post',
    data
  });
}

/* 可视化 - 淘汰记录统计 */
export function findScreenDataOutCount_LB(data) {
  return request({
    url: url + '/seedstock/seedLivestockOperateInfo/findScreenDataOutCount',
    method: 'post',
    data
  });
}

/* 可视化 - 饲喂品种 */
export function getDataByDynamicCode_LB(data) {
  return request({
    url: url + '/pasture/dynamicData/getDataByDynamicCode',
    method: 'post',
    data
  });
}

/* 可视化 - 地图数据统计 */
export function screenFarmForMapFinal_LB(data) {
  return request({
    url: url + '/seedstock/screen/screenFarmForMapFinal',
    method: 'post',
    data
  });
}

/* 可视化 - 获取地图种畜存栏/审核中/已驳回统计 */
export function screenFarmSeedCount_LB(data) {
  return request({
    url: url + '/seedstock/screen/screenFarmSeedCount',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务管理 */
export function pageTaskList_LB(data) {
  return request({
    url: url + '/seedstock/taskManagement/pageTaskList',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务管理 - 新增 */
export function saveTask_LB(data) {
  return request({
    url: url + '/seedstock/taskManagement/saveTask',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务管理 - 修改 */
export function updateTask_LB(data) {
  return request({
    url: url + '/seedstock/taskManagement/updateTask',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务管理 - 删除 */
export function deleteTask_LB(data) {
  return request({
    url: url + '/seedstock/taskManagement/deleteTask',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务管理 - 牧场列表 */
export function pageExecuteFarmList_LB(data) {
  return request({
    url: url + '/seedstock/taskManagement/pageExecuteFarmList',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 列表 */
export function getSeedPerformanceIndicatorPage_LB(data) {
  return request({
    url: url + '/seedstock/indicator/getSeedPerformanceIndicatorPage',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 新增 */
export function savePerformanceIndicator_LB(data) {
  return request({
    url: url + '/seedstock/indicator/savePerformanceIndicator',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 修改 */
export function updateIndicatorById_LB(data) {
  return request({
    url: url + '/seedstock/indicator/updateIndicatorById',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 验证是否可以修改 */
export function checkIndicatorUsed_LB(data) {
  return request({
    url: url + '/seedstock/indicator/checkIndicatorUsed',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 删除 */
export function removeIndicatorById(data) {
  return request({
    url: url + '/seedstock/indicator/removeIndicatorById',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标项 - 列表筛选项 */
export function findSeedPerformanceIndicatorList_LB(data) {
  return request({
    url: url + '/seedstock/indicator/findSeedPerformanceIndicatorList',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标值配置 - 列表 */
export function findIndicatorConfigItemList_LB(data) {
  return request({
    url: url + '/seedstock/indicatorConfigItem/findIndicatorConfigItemList',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标值配置 - 添加 */
export function addIndicatorConfigItem_LB(data) {
  return request({
    url: url + '/seedstock/indicatorConfigItem/addIndicatorConfigItem',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标值配置 - 删除 */
export function delIndicatorConfigItem_LB(data) {
  return request({
    url: url + '/seedstock/indicatorConfigItem/delIndicatorConfigItem',
    method: 'post',
    data
  });
}

/* 性能指标 - 指标值配置 - 批量添加配置 */
export function batchAddIndicatorConfigItem_LB(data) {
  return request({
    url: url + '/seedstock/indicatorConfigItem/batchAddIndicatorConfigItem',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务列表 - 填报列表 pageLivestock_LB */
export function getLivestockListIndicator_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/getLivestockListIndicator',
    method: 'post',
    data
  });
}

/* 性能指标 - 任务列表 - 查询任务已经填报过的畜只列表 */
export function getLivestockListByTaskId_LB(data) {
  return request({
    url: url + '/seedstock/livestockInfo/getLivestockListByTaskId',
    method: 'post',
    data
  });
}

// 查询畜只最近的指标值
export function findLastLivestockIndicatorList_LB(data) {
  return request({
    url: url + '/seedstock/seedPerformanceIndicatorConfig/findLastLivestockIndicatorList',
    method: 'post',
    data
  });
}

// 查询畜只指标值历史记录
export function getSeedLivestockIndicatorHistory_LB(data) {
  return request({
    url: url + '/seedstock/livestockIndicator/getSeedLivestockIndicatorHistory',
    method: 'post',
    data
  });
}

// 大屏 - 无害化处理记录
export function getScreenHarmlessInfo_LB(data) {
  return request({
    url: url + '/seedstock/treatment/getScreenHarmlessInfo',
    method: 'post',
    data
  });
}

// 物料管理
// 物料信息 - 分类
export function countMatterInfoByCategory_LB(data) {
  return request({
    url: url + '/livestock/mattercategory/m/countMatterInfoByCategory',
    method: 'post',
    data
  });
}

// 物料信息 - 列表
export function pageMatterInfo_LB(data) {
  return request({
    url: url + '/livestock/matterinfo/m/pageMatterInfo',
    method: 'post',
    data
  });
}

// 入库/使用记录 - 列表
export function pageMatterRecord_LB(data) {
  return request({
    url: url + '/livestock/matterrecord/m/pageMatterRecord',
    method: 'post',
    data
  });
}

// 系谱档案管理 - 系谱图
export function findFamilyLivestockInfoList_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/findFamilyLivestockInfoList',
    method: 'post',
    data
  });
}

// 系谱档案管理 - 系谱档案 - 列表
export function getLivestockTableTree_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/getLivestockTableTree',
    method: 'post',
    data
  });
}

// 系谱档案管理 - 系谱档案 - 繁育记录（查看）
export function getLivestockTableTreeBreedList_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/getLivestockTableTreeBreedList',
    method: 'post',
    data
  });
}

// 系谱档案管理 - 系谱档案 - 畜只来源
export function getSeedLivestockInfo_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/getSeedLivestockInfo',
    method: 'post',
    data
  });
}

// 系谱档案管理 - 系谱档案 - 繁育记录
export function breedingInfoList_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/breedingInfoList',
    method: 'post',
    data
  });
}

/* 种畜管理 - 检测上报  - 列表 */
export function getCheckResultReportList_LB(data) {
  return request({
    url: url + '/seedstock/checkInfo/getCheckResultReportList',
    method: 'post',
    data
  });
}

/* 信息发布管理 */
// 信息分类设置 - 列表
export function selectNoticeClassifyList_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/selectNoticeClassifyList',
    method: 'post',
    data
  });
}

// 信息分类设置 - 新增
export function saveClassify_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/saveClassify',
    method: 'post',
    data
  });
}

// 信息分类设置 - 修改
export function updateClassify_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/updateClassify',
    method: 'post',
    data
  });
}

// 信息分类设置 - 删除
export function removeClassify_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/removeClassify',
    method: 'post',
    data
  });
}

// 信息发布管理 - 列表
export function pageNotice_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/pageCommonNotice',
    method: 'post',
    data
  });
}

// 信息发布管理 - 编辑/删除
export function updateNotice_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/updateCommonNotice',
    method: 'post',
    data
  });
}

// 信息发布管理- 批量删除
export function removeBatchNotice_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/deleteCommonNotice',
    method: 'post',
    data
  });
}

// 信息发布管理 - 保存
export function saveNotice_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/saveCommonNotice',
    method: 'post',
    data
  });
}

// 信息发布管理 - 获取当前选中牧场信息
export function getFarmInfoByMsgId_LB(data) {
  return request({
    url: url + '/base-server/homeCenter/commonNotice/getFarmInfoByMsgId',
    method: 'post',
    data
  });
}

// 近交系数 - 计算
export function getLivestockRelativeNum_LB(data) {
  return request({
    url: url + '/livestock/livestockInfo/getLivestockRelativeNum',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/breedingLivestockApi.js